import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../../../core'
import * as personas from '../../../../personas'
import * as changeImpactPersona from '../change-impact-persona'

export const RESOURCE = {
  payload: {
    canBeOptional: false,
    context: core.dms.models.Attribute.Id.Context.from({
      context: changeImpactPersona.RESOURCE.payload.dimension.partialId,
      partialId: changeImpactPersona.RESOURCE.payload.partialId,
      type: core.dms.models.Type.Entity,
    }),
    description: 'Persona affected by the change impact',
    isOptional: false,
    name: 'Persona',
    partialId: PartialId.Standard.create('persona'),
    type: {
      dimensionId: core.dms.models.Dimension.Id.from(personas.RESOURCE.payload),
    },
  },
  type: core.quiver.Resource.Type.DmsAttribute,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsAttribute>
